import React from 'react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Calendar, Plus, Trash2, Clock } from 'lucide-react';

export function FacilitiesCard({ facilities, onDelete, onCreate, onManageSlots }) {
  return (
    <Card className="shadow-lg border-0">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="flex items-center gap-2"><Calendar className="w-5 h-5" /> Facilities</CardTitle>
        <Button data-testid="create-facility-button" onClick={onCreate} size="sm" className="bg-gk-teal hover:bg-gk-teal-hover">
          <Plus className="w-4 h-4 mr-1" /> Add Facility
        </Button>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {facilities.length === 0 ? (
            <p className="text-center text-slate-500 py-8">No facilities added</p>
          ) : facilities.map((facility) => (
            <div key={facility.id} data-testid={`facility-item-${facility.id}`} className="p-4 bg-slate-50 rounded-lg">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <h4 className="font-semibold mb-1">{facility.name}</h4>
                  <p className="text-sm text-slate-600 mb-1">{facility.description}</p>
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="text-xs text-slate-500">Rooms: {facility.capacity}</p>
                    {facility.room_type && <span className="text-xs bg-gk-bg text-gk-navy px-2 py-0.5 rounded">{facility.room_type}</span>}
                    {facility.charges_per_night ? <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded font-semibold">&#8377;{facility.charges_per_night}/night</span> : null}
                  </div>
                  {(facility.checkin_time || facility.checkout_time) && (
                    <div className="flex items-center gap-1 mt-1.5">
                      <Clock className="w-3 h-3 text-slate-400" />
                      <span className="text-xs text-slate-500">
                        Check-in: {facility.checkin_time || '11:00 AM'} | Check-out: {facility.checkout_time || '11:00 AM'}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {facility.bookings && facility.bookings.length > 0 && (
                <div className="mt-3 pt-3 border-t"><p className="text-xs font-semibold text-slate-700 mb-2">Bookings: {facility.bookings.length}</p></div>
              )}
              {facility.blocked_slots && facility.blocked_slots.length > 0 && (
                <div className="mt-2"><p className="text-xs font-semibold text-red-600 mb-1">Blocked Dates: {facility.blocked_slots.length}</p></div>
              )}
              <div className="flex gap-2 mt-3">
                <Button data-testid={`manage-slots-${facility.id}`} onClick={() => onManageSlots(facility)} size="sm" variant="outline" className="flex-1">Manage Availability</Button>
                <Button data-testid={`delete-facility-${facility.id}`} onClick={() => onDelete(facility.id)} size="sm" variant="outline" className="text-red-600 hover:bg-red-50"><Trash2 className="w-4 h-4" /></Button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
